import type { LucideIcon } from 'lucide-react'
import {
	type I18nKeys,
	useTranslation,
} from '@/shared/core/hooks/use-translation/use-translation.ts'
import '@/teams/portfolio/components/section/home-section/ai-indicator/feature-badge/feature-badge.scss'

interface FeatureBadgeProps {
	className?: string
	icon?: LucideIcon
	labelKey: I18nKeys
}

export function FeatureBadge({
	labelKey,
	icon: Icon,
	className,
}: Readonly<FeatureBadgeProps>) {
	const { t } = useTranslation()
	const classes = ['feature-badge', className].filter(Boolean).join(' ')

	return (
		<span className={classes} data-testid='feature-badge'>
			{Icon && <Icon aria-hidden='true' className='feature-badge__icon' />}
			{t(labelKey)}
		</span>
	)
}
